import React from 'react';
import './ApplicationTimeline.css';

const SL = { new: 'Новая', in_progress: 'В работе', completed: 'Завершена', cancelled: 'Отменена' };

const ApplicationTimeline = ({ application, users = [] }) => {
  if (!application) return null;

  const events = [];

  // Событие создания
  events.push({
    type: 'created',
    date: new Date(application.createdAt),
    title: 'Заявка создана',
    description: `${application.name} | ${application.service || '—'}`,
    icon: '📋',
    color: '#3b82f6'
  });

  // События из assignmentHistory
  if (application.assignmentHistory) {
    application.assignmentHistory.forEach(h => {
      events.push({
        type: 'assignment',
        date: new Date(h.timestamp),
        title: 'Переназначение',
        description: `${h.from?.name || 'Не назначен'} → ${h.to?.name || 'Неизвестен'}`,
        reason: h.reason,
        icon: '👨‍💼',
        color: '#8b5cf6'
      });
    });
  }

  // События из комментариев (статус)
  if (application.comments) {
    application.comments.forEach(c => {
      if (c.fromStatus && c.toStatus) {
        events.push({
          type: 'status_change',
          date: new Date(c.createdAt),
          title: `Статус: ${SL[c.fromStatus] || c.fromStatus} → ${SL[c.toStatus] || c.toStatus}`,
          description: c.text || 'Статус изменён',
          user: c.userName,
          icon: '🔄',
          color: c.toStatus === 'completed' ? '#22c55e' : c.toStatus === 'cancelled' ? '#ef4444' : '#f59e0b'
        });
      } else if (c.assigneeChanged) {
        events.push({
          type: 'assignee_change',
          date: new Date(c.createdAt),
          title: `Ответственный: ${c.assigneeChanged.from} → ${c.assigneeChanged.to}`,
          description: c.text,
          user: c.userName,
          icon: '👨‍💼',
          color: '#8b5cf6'
        });
      } else {
        events.push({
          type: 'comment',
          date: new Date(c.createdAt),
          title: `Комментарий от ${c.userName || 'Система'}`,
          description: c.text,
          user: c.userName,
          icon: '💬',
          color: '#64748b'
        });
      }
    });
  }

  // Если есть дедлайн — добавляем
  if (application.dueDate) {
    events.push({
      type: 'deadline',
      date: new Date(application.dueDate),
      title: 'Дедлайн',
      description: `SLA: ${application.slaHours || 24} ч.`,
      icon: '⏰',
      color: application.isOverdue ? '#ef4444' : '#22c55e'
    });
  }

  // Если есть completedAt — добавляем
  if (application.completedAt) {
    events.push({
      type: 'completed',
      date: new Date(application.completedAt),
      title: 'Заявка завершена',
      description: application.timeToComplete !== null ? `Выполнено за ${application.timeToComplete} ч.` : '',
      icon: '✅',
      color: '#22c55e'
    });
  }

  // Сортировка по дате (от новых к старым)
  events.sort((a, b) => b.date - a.date);

  return (
    <div className="application-timeline">
      <h4>📊 Хронология событий</h4>
      <div className="timeline">
        {events.map((event, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-marker" style={{ background: event.color }}>
              <span className="timeline-icon">{event.icon}</span>
            </div>
            <div className="timeline-content">
              <div className="timeline-header">
                <span className="timeline-title">{event.title}</span>
                <span className="timeline-date">
                  {event.date.toLocaleString('ru-RU', {
                    day: 'numeric', month: 'short',
                    hour: '2-digit', minute: '2-digit'
                  })}
                </span>
              </div>
              <p className="timeline-description">{event.description}</p>
              {event.reason && (
                <p className="timeline-reason">Причина: {event.reason}</p>
              )}
              {event.user && (
                <span className="timeline-user">{event.user}</span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApplicationTimeline;